module.exports = __webpack_public_path__ + "static/img/16.6008a55.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/zh/16.png
// module id = R0Ka
// module chunks = 0